import { translate } from '../helpers/translate.helper';
import { InfoPopover } from '../InfoPopover/InfoPopover';
import { Box } from '../ui/Box';

interface HistoricBuyerRefPopoverProps {
    references: string[];
}

export const HistoricBuyerRefPopover = ({ references }: HistoricBuyerRefPopoverProps) => (
    <Box display="inline-flex" color="foreground.default">
        <InfoPopover>
            {translate('order.previousBuyerReferences.info', {
                references: references.join(', '),
            })}
        </InfoPopover>
    </Box>
);
